<style lang="scss" scoped>

    .dropdown{
        max-width: 300px;
    }

</style>


<template>

    <div>

        <div class="position-relative pr-xxl-4" v-if="product.available_for_order">

            <span class="h4 text-dark text-center text-lg-left w-100 d-inline-block">
                <span>€</span> <span>{{ price }}</span>
            </span>

            <div class="container px-0 my-4">
                <div class="row pb-2 pr-0">
                    <div class="col-12 d-flex justify-content-between">
                        <div class="dropdown w-100 flex-grow-1" v-if="years != null && typeof years != 'undefined' && years.length > 0">
                            <button class="btn btn-neutral btn-neutral--smaller btn-neutral--empty btn-neutral--dropdown dropdown-toggle d-inline-flex pl-3 pr-0 mw-auto w-100" type="button" id="dropdownYears" data-bs-toggle="dropdown" aria-expanded="false">
                                <span class="text-uppercase d-flex flex-grow-1 justify-content-start">
                                    <span class="text-uppercase">{{$root.translateString('year')}}</span>: {{selected_year}}
                                </span>
                                <img class="mr-3" alt="icona" src="/images/icone-21.svg" width="9"/>
                            </button>
                            <div class="close-background"></div>
                            <ul class="dropdown-menu" aria-labelledby="dropdownYears">
                                <li
                                    v-for="(year, index) in years"
                                    :key="index"
                                    @click="selectYear(year.value)"
                                >
                                    <a href="javascript:void(0)" class="dropdown-item px-3 text-uppercase">
                                        <span class="text-smaller-90">{{year.name}}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="px-2" v-if="typeof formats != 'undefined' && formats.length > 0 && typeof years != 'undefined' && years.length > 0"></div>
                        <div class="dropdown w-100 flex-grow-1" v-if="typeof formats != 'undefined' && formats.length > 0">
                            <button class="btn btn-neutral btn-neutral--smaller btn-neutral--empty btn-neutral--dropdown dropdown-toggle d-inline-flex pl-3 pr-0 mw-auto w-100" type="button" id="dropdownFormat" data-bs-toggle="dropdown" aria-expanded="false">
                                <span class="text-uppercase d-flex flex-grow-1 justify-content-start">
                                    <span class="text-uppercase">{{$root.translateString('format')}}</span>: {{translateFormatInVolume(selected_format)}}
                                </span>
                                <img class="mr-3" alt="icona" src="/images/icone-21.svg" width="9"/>
                            </button>
                            <div class="close-background"></div>
                            <ul class="dropdown-menu" aria-labelledby="dropdownFormat">
                                <li
                                    v-for="(format, index) in formats"
                                    :key="index"
                                    @click="selectFormat(format.value)"
                                >
                                    <a href="javascript:void(0)" class="dropdown-item px-3 text-uppercase">
                                        <span class="text-smaller-90">{{format.name}}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="quantity-controls d-flex align-items-center justify-content-between border-top border-bottom py-3">
                <div class="d-inline-flex mr-45">
                    <div class="quantity-controls--minus d-flex align-items-center justify-content-start pl-2" @click="buy.qty > 1 ? buy.qty-- : 1">
                        <div class="corner"></div>
                        <img src="/images/icone-27.svg" width="10" alt="icona" />
                    </div>

                    <div class="quantity-controls--input d-inline-flex align-items-center justify-content-center">
                        <input readonly type="text" v-model="buy.qty" />
                    </div>

                    <div class="quantity-controls--plus d-flex align-items-center justify-content-end pr-2" @click="buy.qty < 30 ? buy.qty++ : 30">
                        <div class="corner"></div>
                        <img src="/images/icone-23.svg" width="9" alt="icona" />
                    </div>
                </div>
                <a @click="addToCart" class="btn btn-primary text-uppercase flex-grow-1" href="javascript:void(0)"><span>{{$root.translateString('add_to_cart')}}</span></a>
            </div>

            <!--<span class="alert alert-success mt-4 mb-0 d-inline-block text-center w-100" v-if="added_to_cart"><span>{{$root.translateString('added_to_cart')}}</span></span>-->

            <div class="shop-perks my-4 py-2">
                <div class="d-flex mb-3 align-items-center">
                    <div class="d-flex align-items-center justify-content-center img-flex-container">
                        <img class="mr-2" alt="icona" src="/images/icone-19.svg" width="22"/>
                    </div>
                    <span class="pl-1 h6 mb-0 text-primary">
                        {{$root.translateString('shipping-text')}} € 95,00
                    </span>
                </div>
                <div class="d-flex mb-3 align-items-center">
                    <div class="d-flex align-items-center justify-content-center img-flex-container">
                        <img class="mr-2" alt="icona" src="/images/icone-20.svg" width="16"/>
                    </div>
                    <span class="pl-1 h6 mb-0 text-dark">
                        {{$root.translateString('shop-plus-1')}}
                    </span>
                </div>
                <div class="d-flex mb-1 align-items-center">
                    <div class="d-flex align-items-center justify-content-center img-flex-container">
                        <img class="mr-2" alt="icona" src="/images/icone-22.svg" width="16"/>
                    </div>
                    <span class="pl-1 h6 mb-0 text-dark">
                        {{$root.translateString('shop-plus-2')}}
                    </span>
                </div>
            </div>

            <div class="custom-accordion d-flex flex-column border-top">
                <a class="d-flex w-100 border-bottom py-3 text-decoration-none attachment-tab" v-if="product['attachment_' + lang] != '' && product['type'] != 'vini'" target="_blank" :href="product['attachment_' + lang]">
                    <span class="flex-grow-1">
                        <span class="h6 text-uppercase">{{$root.translateString('product-sheet')}}</span>
                    </span>
                    <img alt="icona" width="14" src="/images/download-primary.svg"/>
                </a>
                <div class="d-flex flex-column w-100 border-bottom py-3">
                    <a href="javascript:void(0)" class="d-flex w-100 text-decoration-none accordion-tab" @click="description_is_open = !description_is_open">
                        <span class="flex-grow-1">
                            <span class="h6 text-uppercase">{{$root.translateString('description')}}</span>
                        </span>
                        <img alt="icona" :class="{'rotate-up' : description_is_open}" width="10" src="/images/icone-21-primary.svg"/>
                    </a>
                    <span class="expanded-content" :style="description_is_open ? 'height:' + description_height + 'px' : 'height:0px'" :class="{'expand' : description_is_open}">
                        <p class="text-dark mb-0 mt-3" v-html="product['description_' + lang]"></p>
                    </span>
                </div>
            </div>

            <div v-for="(combination, index) in product.combinations" v-if="['name', 'alcohol', 'producer', 'country', 'allergens'].some(key => combination[key])" class="custom-accordion d-flex flex-column ">
                <div class="d-flex flex-column w-100 border-bottom py-3">
                    <a href="javascript:void(0)" class="d-flex w-100 text-decoration-none accordion-tab" @click="data_sheet_is_open = !data_sheet_is_open">
                        <span class="flex-grow-1">
                            <span class="h6 text-uppercase">{{$root.translateString('data-sheet')}} ({{ combination.attributes.find(attr => attr.key === 'anno')?.value }})</span>
                        </span>
                        <img alt="icona" :class="{'rotate-up' : data_sheet_is_open}" width="10" src="/images/icone-21-primary.svg"/>
                    </a>
                    <span class="expanded-content-data" :style="data_sheet_is_open ? 'height:' + data_sheet_height + 'px' : 'height:0px'" :class="{'expand' : data_sheet_is_open}">
                        <div v-if="combination['name']" class="row mt-2 mb-1">
                            <div class="col-4 text-primary font-italic">
                                {{$root.translateString('denomination')}}
                            </div>
                            <div class="col-8" v-html="combination['name']"></div>
                        </div>
                        <div v-if="combination['alcohol']" class="row mb-1">
                            <div class="col-4 text-primary font-italic">
                                {{$root.translateString('alcohol')}}
                            </div>
                            <div class="col-8" v-html="combination['alcohol']"></div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-4 text-primary font-italic">
                                {{$root.translateString('format')}}
                            </div>
                            <div class="col-8" v-html="translateFormatInVolume(selected_format)"></div>
                        </div>
                        <div v-if="combination['producer']" class="row mb-1">
                            <div class="col-4 text-primary font-italic">
                                {{$root.translateString('producer')}}
                            </div>
                            <div class="col-8" v-html="combination['producer']"></div>
                        </div>
                        <div v-if="combination['country']" class="row mb-1">
                            <div class="col-4 text-primary font-italic">
                                {{$root.translateString('land')}}
                            </div>
                            <div class="col-8" v-html="combination['country']"></div>
                        </div>
                        <div v-if="combination['allergens']" class="row">
                            <div class="col-4 text-primary font-italic">
                                {{$root.translateString('allergens')}}
                            </div>
                            <div class="col-8" v-html="combination['allergens']"></div>
                        </div>
                    </span>
                </div>
            </div>

        </div>

        <div class="position-relative" v-else>
            <div class="w-100">
                <span class="text-red mb-0 text-center text-lg-left w-100">- {{$root.translateString('not_available')}} -</span>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: ['productProp', 'qsFormat', 'qsYear', 'qsAdwordsProp', 'lang', 'freeShippingAt', 'showRecycle'],
    data() {
        return {
            main_selector: 'year',
            default_format: 'bottiglia',
            default_year: '',
            selected_code: '',
            selected_format: '',
            selected_year: '',
            product: this.productProp,
            qsAdwords: typeof this.qsAdwordsProp != 'undefined' ? this.qsAdwordsProp : null,
            combinations: {
            },
            formats: [],
            years: [],
            buy: {
                type: 'product',
                id: null,
                qty: 1
            },
            added_to_cart: false,
            description_is_open: true,
            data_sheet_is_open: true,
            description_height: 'auto',
            data_sheet_height: 'auto',
        }
    },
    created() {
        if(['accessori', 'confezioni', 'gift-card'].includes(this.product.type)) {
            this.default_format = this.product.combinations[0].code;
            this.main_selector = this.product.combinations[0].code;
        }

        if(this.product.type == 'grappe') {
            this.default_format = this.product.combinations[0].code;
            this.main_selector = this.product.combinations[0].code;
            this.selected_format = this.default_format;
        }

        this.product.combinations.sort(function(a, b) {
            return parseFloat(a.price) - parseFloat(b.price);
        });

        this.buy.id = this.product.id;

        let tmp_first_format = '';
        let default_format_exist = false;
        let tmp_formats = [];

        let tmp_first_year = '';
        let default_year_exist = false;
        let tmp_years = [];

        for (let [key, combination] of Object.entries(this.product.combinations)) {

            let weight = 1;

            if(typeof combination.weight != 'undefined') {
                weight = parseFloat(combination.weight);
            }

            this.combinations[combination.code] = {
                code: combination.code,
                price: combination.price,
                weight: weight,
                attributes: {}
            };

            if(combination.attributes.length > 0) {

                for (let attribute of combination.attributes) {
                    this.combinations[combination.code].attributes[attribute.key] = attribute;

                    if(attribute.key == 'formato' && !tmp_formats.includes(attribute.value)) {
                        if(key == 0) {
                            tmp_first_format = attribute.value;
                        }

                        if(attribute.value == this.default_format) {
                            default_format_exist = true;
                        }

                        tmp_formats.push(attribute.value);

                        this.formats.push({
                            value: attribute.value,
                            name: attribute.value_label,
                            combination: combination.code
                        })
                    }


                    if(attribute.key == 'anno' && !tmp_years.includes(parseInt(attribute.value))) {

                        if(tmp_first_year < parseInt(attribute.value)) {
                            tmp_first_year = parseInt(attribute.value);
                        }

                        if(parseInt(attribute.value) == parseInt(this.default_year)) {
                            default_year_exist = true;
                        }

                        tmp_years.push(parseInt(attribute.value));

                        this.years.push({
                            value: parseInt(attribute.value),
                            name: attribute.value_label,
                            combination: combination.code
                        })
                    }

                }

            }
        }

        this.years.sort(function(a, b) {
            return parseFloat(b.value) - parseFloat(a.value);
        });

        /**/

        //select wine from querystring

        if(this.product.type == "vini" && this.showRecycle == false ) {
            if(typeof this.qsFormat != 'undefined' && this.qsYear != 'undefined') {
                if(this.qsYear != null && tmp_years.includes(parseInt(this.qsYear))) {
                    this.selectYear(parseInt(this.qsYear));
                }else{
                    if(default_year_exist == true) {
                        this.selectYear(this.default_year);
                    } else {
                        this.selectYear(tmp_first_year);
                    }
                }

                if(this.qsFormat != null && tmp_formats.includes(this.qsFormat)) {
                    this.selectFormat(this.qsFormat.toLowerCase());
                }else{
                    if(default_format_exist == true) {
                        this.selectFormat(this.default_format);
                    } else {
                        this.selectFormat(tmp_first_format);
                    }
                }
            }
        }

    },
    mounted: function () {

        this.description_height = document.querySelector('.expanded-content').clientHeight;
        this.data_sheet_height = document.querySelector('.expanded-content-data').clientHeight;
        this.description_is_open = false;
        this.data_sheet_is_open = false;

        document.addEventListener('resize', () => {
            this.description_height = document.querySelector('.expanded-content').clientHeight;
            this.data_sheet_height = document.querySelector('.expanded-content-data').clientHeight;
        })

        gtag('event', 'view_item', {
            "items": [
                {
                    'name': this.product.name,
                    'id': this.product.id,
                    'price': this.price,
                    'brand': 'Azienda Agricola Pravis',
                    'quantity': 1,
                    'category': this.type,
                    'variant': this.selected_format + ' - ' + this.selected_year
                }
            ]
        });

    },
    methods: {
        translateFormatInVolume(format) {

            let bottle_size = '0.75L';

            switch(format.toLowerCase()) {
                case 'magnum':
                    bottle_size = '1.5L';
                    break;
                case 'bottiglia':
                    bottle_size = '0.75L'
                    break;
                case 'mezza-bottiglia':
                    bottle_size = '0.375L'
                    break;
            }

            this.formats.forEach(y => {
                switch(y.name.toLowerCase()) {
                    case 'bottiglia 0.5l':
                        bottle_size = '0.5L';
                        break;
                    case 'bottiglia 0.7l':
                        bottle_size = '0.7L';
                        break;
                    case 'bottiglia 1l':
                        bottle_size = '1L';
                        break;
                }
            });

            return bottle_size;

        },
        selectFormat(format)
        {
            if(this.main_selector == 'format') {
                this.years = [];
                for (let [k, c] of Object.entries(this.combinations)) {
                    if(c.attributes.formato.value == format) {
                        //console.log(c);
                        if(typeof c.attributes.anno != 'undefined') {
                            this.years.push({
                                value: c.attributes.anno.value,
                                name: c.attributes.anno.value_label,
                                combination: c.code
                            });
                        } else {
                            //se non abbiamo l'anno è singola.
                            this.selected_code = c.code;
                        }
                    }
                }

                if(this.years.length > 0) {
                    this.selected_year = this.years[0].value;
                    this.selected_code = this.years[0].combination;
                } else {
                    this.selected_year = null;
                }
            } else {
                this.formats.forEach(y => {
                    if(y.value == format) {
                        this.selected_code = y.combination;
                    }
                });
            }

            this.selected_format = format;

            let format_qs = '?format=' + this.selected_format;
            let year_qs = '&year=' + this.selected_year;
            if(this.selected_format == '') {
                format_qs = '';
            }
            if(this.selected_year == '') {
                year_qs = '';
            }
            if(this.qsAdwords == null && this.product.type == "vini" && this.showRecycle == false ) {
                if(this.product.category != null) {
                    history.replaceState({}, this.product.name, '/' + this.lang + '/shop/' + this.$root.slugifyType(this.lang, this.product.type) + '/' + this.product.category + '/' + this.product.link_rewrite + format_qs + year_qs);
                }else{
                    history.replaceState({}, this.product.name, '/' + this.lang + '/shop/' + this.$root.slugifyType(this.lang, this.product.type) + '/' + this.product.link_rewrite + format_qs + year_qs);
                }
            }

            if(typeof this.qsAdwords != null) {
                this.qsAdwords = null;
            }

        },
        selectYear(year)
        {
            this.formats = [];
            let local_default_format_exist = null;
            if(this.main_selector == 'year') {
                for (let [k, c] of Object.entries(this.combinations)) {
                    if(c.attributes.anno.value == year) {
                        //console.log(c);
                        if(typeof c.attributes.anno != 'undefined') {
                            this.formats.push({
                                value: c.attributes.formato.value,
                                name: c.attributes.formato.value_label,
                                combination: c.code
                            });
                            if(typeof this.default_format != 'undefined' && this.default_format != null) {
                                if(c.attributes.formato.value === this.default_format) {
                                    local_default_format_exist = {
                                        value: c.attributes.formato.value,
                                        combination: c.code
                                    };
                                }
                            }
                        } else {
                            //se non abbiamo il formato è singola.
                            this.selected_code = c.code;
                        }
                    }
                }

                if(this.formats.length > 0) {

                    if(local_default_format_exist !== null) {
                        this.selected_format = local_default_format_exist.value;
                        this.selected_code = local_default_format_exist.combination;
                    } else {
                        this.selected_format = this.formats[0].value;
                        this.selected_code = this.formats[0].combination;
                    }
                } else {
                    this.selected_year = null;

                }
            } else {
                this.years.forEach(y => {
                    if(y.value == year) {
                        this.selected_code = y.combination;
                    }
                });
            }

            this.selected_year = year;
            if(this.qsAdwords == null && this.product.type == "vini" && this.showRecycle == false ) {
                if(this.product.category != null) {
                    history.replaceState({}, this.product.name, '/' + this.lang + '/shop/' + this.$root.slugifyType(this.lang, this.product.type) + '/' + this.product.category + '/' + this.product.link_rewrite + '?format=' + this.selected_format + '&year=' + this.selected_year);
                }else{
                    history.replaceState( {} , this.product.name, '/' + this.lang + '/shop/' +  this.$root.slugifyType(this.lang, this.product.type) + '/' + this.product.link_rewrite + '?format=' + this.selected_format + '&year=' + this.selected_year );
                }
            }

        },
        addToCart()
        {
            this.buy.combination = this.combinations[this.selected_code];

            if(['accessori', 'sapori', 'collezioni'].includes(this.product.type)) {
                this.buy.combination.attributes = [];
            }

            axios.post('/api/cart/add', this.buy)
                .then(response => {

                    if(response.data.status === true) {

                        try{
                            fbq('track', 'AddToCart',
                                {
                                    value: parseFloat(this.price),
                                    currency: 'EUR',
                                    contents: [
                                        {
                                            id: this.product.name,
                                            quantity: this.buy.qty
                                        },
                                    ],
                                    content_type: 'product',
                                    content_name: this.product.name
                                }
                            );

                            gtag('event', 'add_to_cart', {
                                "items": [
                                    {
                                        'name': this.product.name,
                                        'id': this.product.id,
                                        'price': this.price,
                                        'brand': 'Azienda Agricola Pravis',
                                        'category': this.type,
                                        'variant': this.selected_format + ' - ' + this.selected_year,
                                        'quantity': this.buy.qty,
                                    }
                                ]
                            });
                        }catch(e) {}

                        let buy_qty_memo = this.buy.qty;
                        this.$eventHub.$emit('cart.added', {
                            count: response.data.count,
                            specific_count: buy_qty_memo,
                            product_id: this.product.id,
                            product_code: this.selected_code
                        });

                        //if($(window).width() >= 992) {
                        this.$eventHub.$emit('cart.show', {});
                        //}

                        this.added_to_cart = true;
                        this.buy.qty = 1;
                        this.buy.combination = null;
                        this.selectFormat(this.default_format);
                        setTimeout(() => {
                            this.added_to_cart = false;
                        }, 4000);
                    }

                })
                .catch(err => {
                    //console.log('Error');
                });
        },
    },
    computed: {
        price() {
            if(this.selected_code == '') this.selected_code = this.default_format;
            let base = this.combinations[this.selected_code].price;
            //let qty = this.buy.qty; disabled for now
            let qty = 1;

            return this.$root.currencyDisplaySimple(base * qty);
        }
    }
}
</script>
